// extracted by mini-css-extract-plugin
export var cartIcon = "_lr-0";
export var cartIconContainer = "_lr-1";